import React from "react";
import { useParams } from "react-router-dom";
import { motion } from "framer-motion";
import BlogDetails from "./BlogDetails";

function BlogDetailsWrapper() {
  const { id } = useParams();
  
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5, ease: "easeInOut" }}
    >
      <BlogDetails blogId={id} />
    </motion.div>
  );
}

export default BlogDetailsWrapper;
